import { takeLatest, put } from 'redux-saga/effects';
import {
  appNotify,
  setPostAcqWorkflowLoadingOverlayState,
  editPostAcqTasks,
} from 'store/actions';
import { putWithTokenV2 } from 'api/network';
import { sendClientLog } from 'services/logService';
import { Constants } from 'utilities/constants';

export function* editPostAcqTasksSaga() {
  yield takeLatest(editPostAcqTasks, function* ({ payload }) {
    try {
      const { taskIds, editField, newValue } = payload;
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: true, message: 'Saving edits...' }));
      const req = {
        taskIds,
        fieldName: editField.field,
        fieldType: editField.type,
        fieldValue: newValue
      }
      const editedTaskIds = yield putWithTokenV2(`/api/postAcquisition/tasks/edit`, req);
      yield put(appNotify(`${editedTaskIds.length} task${editedTaskIds.length > 1 ? 's' : ''} updated`, 'success'));
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setPostAcqWorkflowLoadingOverlayState({ isLoading: false, message: null }));
    }
  });
}

